import { UploadFile } from "./generated";

export enum NewsCategory {
  ALL = "All",
  ANNOUNCEMENTS = "Announcements",
  ACCOMMODATION = "Accommodation",
  RESTAURANTS = "Restaurants",
  BANQUETS = "Banquets",
  MAINTENANCE = "Maintenance",
  OTHERS = "Others",
}

export enum NewsCategoryJapanese {
  ALL = "すべて",
  ANNOUNCEMENTS = "お知らせ",
  ACCOMMODATION = "宿泊",
  RESTAURANTS = "レストラン",
  BANQUETS = "バンケット",
  MAINTENANCE = "メンテナンス",
  OTHERS = "その他",
}

export const NEWS_CATEGORY_MAPPING = {
  [NewsCategory.ANNOUNCEMENTS]: NewsCategoryJapanese.ANNOUNCEMENTS,
  [NewsCategory.ACCOMMODATION]: NewsCategoryJapanese.ACCOMMODATION,
  [NewsCategory.RESTAURANTS]: NewsCategoryJapanese.RESTAURANTS,
  [NewsCategory.BANQUETS]: NewsCategoryJapanese.BANQUETS,
  [NewsCategory.MAINTENANCE]: NewsCategoryJapanese.MAINTENANCE,
  [NewsCategory.OTHERS]: NewsCategoryJapanese.OTHERS,
};

export interface INewsCategory {
  label: string;
  value: NewsCategory;
}

export const LIST_NEW_CATEGORY: INewsCategory[] = [
  {
    label: "すべて",
    value: NewsCategory.ALL,
  },
  {
    label: "お知らせ",
    value: NewsCategory.ANNOUNCEMENTS,
  },
  {
    label: "宿泊",
    value: NewsCategory.ACCOMMODATION,
  },
  {
    label: "レストラン",
    value: NewsCategory.RESTAURANTS,
  },
  {
    label: "宴会・会議",
    value: NewsCategory.BANQUETS,
  },
  {
    label: "メンテナンス",
    value: NewsCategory.MAINTENANCE,
  },
  {
    label: "その他",
    value: NewsCategory.OTHERS,
  },
];

export const LatestNewsTab = {
  HOTEL: [
    NewsCategory.ACCOMMODATION,
    NewsCategory.RESTAURANTS,
    NewsCategory.BANQUETS,
  ] as NewsCategory[],
  GROUP: [
    NewsCategory.ANNOUNCEMENTS,
    NewsCategory.MAINTENANCE,
    NewsCategory.OTHERS,
  ] as NewsCategory[],
};
export type LatestNewsTab = (typeof LatestNewsTab)[keyof typeof LatestNewsTab];
export interface INewsItem {
  createdAt: string;
  properties: {
    header_title: string | null;
    hotel_names?: string | null;
    featured_image?: UploadFile | null;
    use_featured_Image: boolean | null;
    category_type?: string | null;
    external_link?: string | null;
    date_created: string;
  };
  item_name: string;
}

export interface GroupedNews {
  [monthYear: string]: INewsItem[];
}

export interface CategoryTabsProps {
  categories: INewsCategory[];
  activeTab: NewsCategory;
  onTabChange: (tab: NewsCategory) => void;
}
